import { render, staticRenderFns } from "./AuditLogsTable.vue?vue&type=template&id=bc0def4a&"
import script from "./AuditLogsTable.vue?vue&type=script&lang=js&"
export * from "./AuditLogsTable.vue?vue&type=script&lang=js&"
import style0 from "./AuditLogsTable.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports